import http from './utils';
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { mockPrefix, prefix } from './constants';
import axios from 'axios';
const CancelToken = axios.CancelToken;

export const getAIAnalysisSummaryList: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> = (payload, cancelTokenFunc = (c) => {}) =>
  http({
    url: `${prefix}/ai_analysis/summary_list`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;

export const deleteAIAnalysisSummary: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c) => {},
) =>
  http({
    url: `${prefix}/ai_analysis/delete_summary`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;

export const getItemAIAnalysisSummary: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c) => {}) =>
  http({
    url: `${prefix}/ai_analysis/summary_detail`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;

export const addRepeatSummaryTask: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c) => {}) =>
  http({
    url: `${prefix}/ai_analysis/add_repeat_summary_task`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;

export const updateRepeatSummaryTask: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c) => {}) =>
  http({
    url: `${prefix}/ai_analysis/update_repeat_summary_task`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;

export const getRepeatSummaryTaskList: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c) => {}) =>
  http({
    url: `${prefix}/ai_analysis/repeat_summary_task_list`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;

export const getRepeatSummaryTaskExecutionList: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c) => {}) =>
  http({
    url: `${prefix}/ai_analysis/repeat_summary_task_execution_list`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;

export const getReportViewRecords: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c) => {}) =>
  http({
    url: `${prefix}/view_record/get`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;

export const setReportViewRecords: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c) => {}) =>
  http({
    url: `${prefix}/view_record/set`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;
